import React from 'react';
import { connect } from 'react-redux';
import { Route, Switch, withRouter, RouteComponentProps } from 'react-router-dom';

import SurveyAdd from '~src/modules/surveys/components/add/SurveyAdd';
import PageNotFound from '~src/shared/errorPages/PageNotFound';
import SurveysList from '~src/modules/surveys/components/list/SurveysList';
import SurveyDetails from '~src/modules/surveys/components/details/SurveyDetails';
import { fetchLocales, fetchTimeZones } from '~src/store/session/actions';
import { itemIdMatch } from '~src/constants';
import { ApiReduxResp } from '~src/services/apiMiddleware';

interface DispatchProps {
  fetchTimeZones(): ApiReduxResp;
  fetchLocales(): ApiReduxResp;
}

interface OwnProps {
  isAuthenticated: boolean;
}

type Props = OwnProps & DispatchProps & RouteComponentProps<any>;

class Surveys extends React.Component<Props> {
  componentDidMount() {
    if (this.props.isAuthenticated) {
      this.props.fetchTimeZones();
      this.props.fetchLocales();
    }
  }

  render() {
    const { match } = this.props;
    return (
      <Switch>
        <Route exact strict path={match.url} component={SurveysList} />
        <Route exact strict path={`${match.url}/add`} component={SurveyAdd} />
        <Route path={`${match.url}/:surveyId(${itemIdMatch})`} component={SurveyDetails} />
        <PageNotFound {...this.props} />
      </Switch>
    );
  }
}

const mapDispatchToProps = (dispatch: any): DispatchProps => ({
  fetchTimeZones: () => dispatch(fetchTimeZones()),
  fetchLocales: () => dispatch(fetchLocales()),
});

const SurveysWithRouter = withRouter(Surveys);
const SurveysSuperComponent = connect(null, mapDispatchToProps)(SurveysWithRouter);

export default SurveysSuperComponent;
